import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import AuthGuard from './components/auth-guard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'maintenance',
    //   component: ComingSoon
    // },
    {
      path: '/',
      name: 'home',
      component: Home,
      alias: [
        '/hotels',
        '/kaffeehaeuser',
        '/veranstaltungen',
        '/wellness',
        '/unterkuenfte',
        '/stories',
        '/stifte-kloester-schloesser',
        '/sport',
        '/museen',
        '/kunst-kultur',
        '/kulinarium',
        '/abenteuer',
        '/ausflugsziele',
        '/bio',
        '/einkaufen',
        '/gasthaeuser',
        '/heurige'
      ]
    },
    {
      path: '/uiw-admin',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/auth/Login.vue')
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: () => import(/* webpackChunkName: "impressum" */ './views/Impressum.vue')
    },
    {
      path: '/unser-angebot',
      name: 'angebot',
      component: () => import(/* webpackChunkName: "angebot" */ './views/Angebot.vue')
    },
    {
      path: '/snippets',
      name: 'snippets',
      component: () => import(/* webpackChunkName: "snippets" */ './views/Snippets.vue')
    },
    {
      path: '/details/:niceUrl',
      name: 'details',
      props: true,
      component: () => import(/* webpackChunkName: "details" */ './views/Article.vue')
    },
    {
      path: '/cms/list',
      name: 'list',
      component: () => import(/* webpackChunkName: "list" */ './views/cms/List.vue'),
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/create',
      name: 'create',
      component: () => import(/* webpackChunkName: "create" */ './views/cms/Create.vue'),
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/files',
      name: 'files',
      component: () => import(/* webpackChunkName: "files" */ './views/cms/Files.vue'),
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '/cms/edit/:id',
      name: 'edit',
      component: () => import(/* webpackChunkName: "edit" */ './views/cms/Create.vue'),
      props: true,
      beforeEnter: AuthGuard.requireUser
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
